
export default function () {
    $('input[type="number"]').styler();

    $('input.js-number-input').on('change', function () {
        let $currentInput = $(this);
        let currentVal = parseInt($currentInput.val());
        let currentMin = parseInt($currentInput.attr('min'));
        let currentMax = parseInt($currentInput.attr('max'));

        setTimeout(function () {
            $currentInput.closest('.jq-number').find('.jq-number__spin').removeClass('disabled');
        }, 5);

        if(currentVal>currentMax) {
            currentVal = currentMax;
            $currentInput.val(currentMax);
        }
        if(currentVal<currentMin) {
            currentVal = currentMin;
            $currentInput.val(currentMin);
        }
        if(currentVal == currentMin){
            setTimeout(function () {
                $currentInput.closest('.jq-number').find('.minus').addClass('disabled');
            }, 5)
        }
        if(currentVal == currentMax){
            setTimeout(function () {
                $currentInput.closest('.jq-number').find('.plus').addClass('disabled');
            }, 5)
        }
    });


    $('input.js-number-input').each(function () {
        let $currentInput = $(this);
        let currentVal = parseInt($currentInput.val());
        let currentMin = parseInt($currentInput.attr('min'));
        let currentMax = parseInt($currentInput.attr('max'));
        if(currentVal == currentMin){
            setTimeout(function () {
                $currentInput.closest('.jq-number').find('.minus').addClass('disabled');
            }, 5)
        }
        if(currentVal == currentMax){
            setTimeout(function () {
                $currentInput.closest('.jq-number').find('.plus').addClass('disabled');
            }, 5)
        }
    });


    $('.js-number-input, input[type="tel"]').keydown(function (event) {
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 || (event.keyCode == 65 && event.ctrlKey === true) || (event.keyCode >= 35 && event.keyCode <= 39)) {
            return;
        } else {
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
            }
        }
    });
}
